
import { executeMutation, executeQuery } from 'utils/services/apiServices';
import { showSnackbar } from 'utils/snack_bar/store/action';
import { actionTypes, AddPackageInput, ClientPayloadProps, CreateVideoInput, fetchPackageByRefIdInput, Packages, SetVideoToAnotherGroupInput, UpdateSingleDataInput, UploadVideoInput, VideoDetailProps, VideoProps, VideoViewCountProps } from 'modules/video/video_detail/store/actionType';
import { CREATE_VIDEO, DELETE_VIDEO, UPSERT_PACKAGE_CONTENTS, UPDATE_SINGLE_DATA_BY_VIDEO_ID, UPDATE_VIDEO, UPLOAD_VIDEO } from 'modules/video/video_detail/graphql/mutation';
import { FETCH_PACKAGE_BY_REF_ID, FETCH_VIDEO_BY_EPISODE, FETCH_VIDEO_VIEWS, SET_VIDEO_TO_ANOTHER_GROUP } from 'modules/video/video_detail/graphql/query';

export const fetchVideoDetailsRequest = () => ({
    type: actionTypes.FETCH_VIDEO_DETAIL_REQUEST
});

export const fetchVideoDetailsSuccess = (payload: VideoProps) => ({
    type: actionTypes.FETCH_VIDEO_DETAIL_SUCCESS,
    payload
});

export const fetchVideoDetailsFail = (payload: string) => ({
    type: actionTypes.FETCH_VIDEO_DETAIL_FAIL,
    payload
});

export const fetchVideoDetails = (episode_id:string) => {
    return async (dispatch: any) => {
        try {
            await dispatch(fetchVideoDetailsRequest());
            const input = {
                episode_id: episode_id
            };
            const response = await executeQuery(FETCH_VIDEO_BY_EPISODE,input);
            const jsonData = response.data?.fetchVideoByEpisode;
            if (jsonData?.error === null) {
                dispatch(fetchVideoDetailsSuccess(jsonData?.data));
            } else {
                dispatch(fetchVideoDetailsFail(jsonData?.error.message));
            }
        } catch (error: any) {
            dispatch(fetchVideoDetailsFail('Failed to fetch video'));
        }
    };
};
//fetch vidoe view
export const fetchVideoViewCountRequest = () => ({
    type: actionTypes.FETCH_VIDEO_VIEW_COUNT_REQUEST
});

export const fetchVideoViewCountSuccess = (payload: VideoViewCountProps[]) => ({
    type: actionTypes.FETCH_VIDEO_VIEW_COUNT_SUCCESS,
    payload
});

export const fetchVideoViewCountFail = (payload: string) => ({
    type: actionTypes.FETCH_VIDEO_VIEW_COUNT_FAIL,
    payload
});

export const fetchVideoViewCount = () => {
    return async (dispatch: any) => {
        try {
            await dispatch(fetchVideoViewCountRequest());
            const response = await executeQuery(FETCH_VIDEO_VIEWS);
            const jsonData = response.data?.fetchVideoViews;
            if (jsonData?.error === null) {
                dispatch(fetchVideoViewCountSuccess(jsonData?.data.video_views));
            } else {
                dispatch(fetchVideoViewCountFail(jsonData?.error.message));
            }
        } catch (error: any) {
            dispatch(fetchVideoViewCountFail('Failed to fetch view count'));
        }
    };
};

//Create video
export const createVideoDetailsRequest= () => ({
    type: actionTypes.CREATE_VIDEO_DETAIL_REQUEST,
});
export const createVideoDetailsSuccess= (payload: VideoProps) => ({
    type: actionTypes.CREATE_VIDEO_DETAIL_SUCCESS,
    payload
});
export const createVideoDetailsFail= (payload: string) => ({
    type: actionTypes.CREATE_VIDEO_DETAIL_FAIL,
    payload
});
export const createVideoDetail = (input: CreateVideoInput) => {
    return async (dispatch: any) => {
        try {
            const inputData = {
                input:input
            }
            await dispatch(createVideoDetailsRequest())
            const response = await executeMutation(CREATE_VIDEO, inputData);
            const jsonData = response.data?.createVideo;
            if (jsonData?.error === null) {
                dispatch(createVideoDetailsSuccess(jsonData?.data));
                 dispatch(showSnackbar('Success! video created.'));
            } else {
                dispatch(createVideoDetailsFail(jsonData?.error.message))
                 dispatch(showSnackbar(`Error :${jsonData?.error.message ? jsonData?.error.message : "Something went wrong"}`))
            }
        } catch (error: any) {
            dispatch(createVideoDetailsFail('Something went wrong, Try again later'))
        }
    };
};

//Update video
export const updateVideoDetailsRequest= () => ({
    type: actionTypes.UPDATE_VIDEO_DETAIL_REQUEST,
});
export const updateVideoDetailsSuccess= (payload: VideoProps) => ({
    type: actionTypes.UPDATE_VIDEO_DETAIL_SUCCESS,
    payload
});
export const updateVideoDetailsFail= (payload: string) => ({
    type: actionTypes.UPDATE_VIDEO_DETAIL_FAIL,
    payload
});
export const updateVideoDetail = (input: CreateVideoInput, video_id:string) => {
    return async (dispatch: any) => {
        try {
            const inputData = {
                input:input,
                video_id: video_id
            }
            await dispatch( updateVideoDetailsRequest())
            const response = await executeMutation(UPDATE_VIDEO, inputData);
            const jsonData = response.data?.editVideo;
            if (jsonData?.error === null) {
                dispatch(updateVideoDetailsSuccess(jsonData?.data));
                 dispatch(showSnackbar('Success! video updated.'));
            } else {
                dispatch(updateVideoDetailsFail(jsonData?.error.message))
               dispatch(showSnackbar(`Error :${jsonData?.error.message ? jsonData?.error.message : "Something went wrong"}`))
            }
        } catch (error: any) {
            dispatch(updateVideoDetailsFail('Something went wrong, Try again later'))
        }
    };
};

// //delete video
export const deleteVideoDetailsRequest= () => ({
    type: actionTypes.DELETE_VIDEO_DETAIL_SUCCESS
});
export const deleteVideoDetailsSuccess= (payload: string) => ({
    type: actionTypes.DELETE_VIDEO_DETAIL_SUCCESS,
    payload
});
export const deleteVideoDeatilsFail= (payload: string) => ({
    type: actionTypes.DELETE_VIDEO_DETAIL_FAIL,
    payload
});
export const deleteVideoDetail = (video_id: string) => {
    return async (dispatch: any) => {
        try {
            const inputData = {
                video_id:video_id,
            }
            await dispatch( deleteVideoDetailsRequest())
            const response = await executeMutation(DELETE_VIDEO, inputData);
            const jsonData = response.data?.deleteVideo;
            if (jsonData?.error === null) {
                dispatch(deleteVideoDetailsSuccess(video_id));
                dispatch(showSnackbar('Success! video deleted.'));
            } else {
                dispatch(deleteVideoDeatilsFail(jsonData?.error.message))
                dispatch(showSnackbar(`Error :${jsonData?.error.message ? jsonData?.error.message : "Something went wrong"}`))
            }
        } catch (error: any) {
            dispatch(deleteVideoDeatilsFail('Something went wrong, Try again later'));
        }
    };
};

//RESET
export const ResetVideo = () => ({
    type: actionTypes.RESET_VIDEO
});

export const resetVideo = () => {
    return async (dispatch: any) => {
        dispatch(ResetVideo());
    };
};

//upload video 
export const uploadVideoRequest= () => ({
    type: actionTypes.UPLOAD_VIDEO_SUCCESS,
});
export const uploadVideoSuccess= (payload: ClientPayloadProps) => ({
    type: actionTypes.UPLOAD_VIDEO_SUCCESS,
    payload
});
export const uploadVideoFail= (payload: string) => ({
    type: actionTypes.UPLOAD_VIDEO_FAIL,
    payload
});
export const uploadVideo = (input: UploadVideoInput) => {
    return async (dispatch: any) => {
        try {
            await dispatch(uploadVideoRequest())
            const response = await executeMutation(UPLOAD_VIDEO, input);
            const jsonData = response.data?.uploadVideo;
            if (jsonData?.error === null) {
                dispatch(uploadVideoSuccess(jsonData?.data.client_playload));
                //  dispatch(showSnackbar('Success! video uploaded.'));
            } else {
                dispatch(uploadVideoFail(jsonData?.error.message))
               dispatch(showSnackbar(`Error :${jsonData?.error.message ? jsonData?.error.message : "Something went wrong"}`))
            }
        } catch (error: any) {
            dispatch(uploadVideoFail('Something went wrong, Try again later'))
        }
    };
};

//upload video  visibility
export const updateVideoVisibilityRequest= () => ({
    type: actionTypes.UPDATE_VIDEO_VISIBILITY_REQUEST,
});
export const updateVideoVisibilitySuccess= (payload: VideoProps) => ({
    type: actionTypes.UPDATE_VIDEO_VISIBILITY_SUCCESS,
    payload
});
export const updateVideoVisibilityFail= (payload: string) => ({
    type: actionTypes.UPDATE_VIDEO_VISIBILITY_FAIL,
    payload
});
export const updateVideoVisibility = (input: UpdateSingleDataInput) => {
    return async (dispatch: any) => {
        try {
            const inputData = {
                input:input,
            }
            await dispatch(updateVideoVisibilityRequest())
            const response = await executeMutation(UPDATE_SINGLE_DATA_BY_VIDEO_ID, inputData);
            const jsonData = response.data?.updateSingleDataByVideoId;
            if (jsonData?.error === null) {
                dispatch(updateVideoVisibilitySuccess(jsonData?.data));
                 dispatch(showSnackbar('Success! video visibility updated.'));
            } else {
                dispatch(updateVideoVisibilityFail(jsonData?.error.message))
                dispatch(showSnackbar(`Error :${jsonData?.error.message ? jsonData?.error.message : "Something went wrong"}`))
            }
        } catch (error: any) {
            dispatch(updateVideoVisibilityFail('Something went wrong, Try again later'))
        }
    };
};

//upload video  Featured
export const updateVideoFeaturedRequest= () => ({
    type: actionTypes.UPDATE_VIDEO_VISIBILITY_REQUEST,
});
export const updateVideoFeaturedSuccess= (payload: VideoDetailProps) => ({
    type: actionTypes.UPDATE_VIDEO_VISIBILITY_SUCCESS,
    payload
});
export const updateVideoFeaturedFail= (payload: string) => ({
    type: actionTypes.UPDATE_VIDEO_VISIBILITY_FAIL,
    payload
});
export const updateVideoFeatured = (input: UpdateSingleDataInput) => {
    return async (dispatch: any) => {
        try {
            const inputData = {
                input:input,
            }
            await dispatch(updateVideoFeaturedRequest())
            const response = await executeMutation(UPDATE_SINGLE_DATA_BY_VIDEO_ID, inputData);
            const jsonData = response.data?.updateSingleDataByVideoId;
            if (jsonData?.error === null) {
                dispatch(updateVideoFeaturedSuccess(jsonData?.data));
                 dispatch(showSnackbar('Success! video Featured updated.'));
            } else {
                dispatch(updateVideoFeaturedFail(jsonData?.error.message))
                dispatch(showSnackbar(`Error :${jsonData?.error.message ? jsonData?.error.message : "Something went wrong"}`))
            }
        } catch (error: any) {
            dispatch(updateVideoFeaturedFail('Something went wrong, Try again later'))
        }
    };
};

//fetch package by ref id
export const fetchPackageByRefIdRequest= () => ({
    type: actionTypes.FETCH_PACKAGE_BY_REF_ID_REQUEST,
});
export const fetchPackageByRefIdSuccess= (payload: Packages[]) => ({
    type: actionTypes.FETCH_PACKAGE_BY_REF_ID_SUCCESS,
    payload
});
export const fetchPackageByRefIdFail= (payload: string) => ({
    type: actionTypes.FETCH_PACKAGE_BY_REF_ID_FAIL,
    payload
});   
export const fetchPackageByRefId = (input_data: fetchPackageByRefIdInput) => {
    return async (dispatch: any) => {
        try {
            await dispatch(fetchPackageByRefIdRequest())
            const response = await executeQuery(FETCH_PACKAGE_BY_REF_ID, input_data);
            const jsonData = response.data?.fetchPackageByRefId;
            if (jsonData?.error === null) {
                dispatch(fetchPackageByRefIdSuccess(jsonData?.data?.package_content));
            } else {
                dispatch(fetchPackageByRefIdFail(jsonData?.error.message))
                dispatch(showSnackbar(`Error :${jsonData?.error.message ? jsonData?.error.message : "Something went wrong"}`))
            }
        } catch (error: any) {
            dispatch(fetchPackageByRefIdFail('Something went wrong, Try again later'))
        }
    };
};
//add package to video
export const addPackageToVideoFeaturedRequest= () => ({
    type: actionTypes.ADD_PACKAGE_TO_VIDEO_REQUEST,
});
export const addPackageToVideoFeaturedSuccess= (payload: Packages[]) => ({
    type: actionTypes.ADD_PACKAGE_TO_VIDEO_SUCCESS,
    payload
});
export const addPackageToVideoFeaturedFail= (payload: string) => ({
    type: actionTypes.ADD_PACKAGE_TO_VIDEO_FAIL,
    payload
});
export const addPackageToVideoFeatured = (input_data: AddPackageInput) => {
    return async (dispatch: any) => {
        try {
            await dispatch(addPackageToVideoFeaturedRequest())
            const response = await executeMutation(UPSERT_PACKAGE_CONTENTS, input_data);
            const jsonData = response.data?.UpsertPackageContents;
            if (jsonData?.error === null) {
                dispatch(addPackageToVideoFeaturedSuccess(jsonData?.data?.package_content));
                 dispatch(showSnackbar('Success! video package updated.'));
            } else {
                dispatch(addPackageToVideoFeaturedFail(jsonData?.error.message))
                dispatch(showSnackbar(`Error :${jsonData?.error.message ? jsonData?.error.message : "Something went wrong"}`))
            }
        } catch (error: any) {
            dispatch(addPackageToVideoFeaturedFail('Something went wrong, Try again later'))
        }
    };
};
export const setVideoToAnotherGroupRequest= () => ({
    type: actionTypes.SET_VIDEO_TO_ANOTHER_GROUP_REQUEST,
});

export const setVideoToAnotherGroupSuccess= () => ({
    type: actionTypes.SET_VIDEO_TO_ANOTHER_GROUP_SUCCESS,
});

export const setVideoToAnotherGroupFail= (payload: string) => ({
    type: actionTypes.SET_VIDEO_TO_ANOTHER_GROUP_FAIL,
    payload
});

export const setVideoToAnotherGroup = (input: SetVideoToAnotherGroupInput, video_id:string) => {
    return async (dispatch: any) => {
        try {
            await dispatch(setVideoToAnotherGroupRequest())
            const response = await executeQuery(SET_VIDEO_TO_ANOTHER_GROUP, {input, video_id});
            const jsonData = response.data?.setVideoToAnotherGroup;
            if (jsonData?.error === null) {
                dispatch(setVideoToAnotherGroupSuccess());
                 dispatch(showSnackbar('Success! video package updated.'));
            } else {
                dispatch(setVideoToAnotherGroupFail(jsonData?.error.message))
                dispatch(showSnackbar(`Error :${jsonData?.error.message ? jsonData?.error.message : "Something went wrong"}`))
            }
        } catch (error: any) {
            dispatch(setVideoToAnotherGroupFail('Something went wrong, Try again later'))
        }
    };
};